import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.to-string.js";
import { reasonListAll } from "@/api/reason";
export var reasonMsg = {
  namespaced: true,
  state: {
    isInit: 0,
    reasonKv: {}
  },
  mutations: {
    setReasonKv: function setReasonKv(state, reasonMap) {
      state.isInit = 1;
      state.reasonKv = reasonMap;
    }
  },
  actions: {
    getReason: function getReason(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, reasonMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return reasonListAll();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                reasonMap = {};
                res.data.list.forEach(function (val) {
                  reasonMap[val.reason_id.toString()] = val.reason_name;
                });
                // dictionaryMap[res.data.resysDictionary.type] = dict
                commit("setReasonKv", reasonMap);
                // return state.dictionaryMap[type]
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    reasonMap: function reasonMap(state) {
      return state.reasonKv;
    }
  }
};